export default __webpack_public_path__ + "static/media/loading.ba5456b1.webp";